interface EventMap {
  [name: string]: Array<(data?: any) => void>;
}

export type EventCallback = (...args: any[]) => void;
export type EventDispose = () => void;

export interface EventsManager {
  subscribe(name: string, func: EventCallback): () => void;
  clearSubscriptions(name: string): EventCallback[];
  publish(name: string, data?: any): void;
}

export class EventsManagerImpl implements EventsManager {
  private static instance: EventsManager;

  public static getInstance(): EventsManager {
    if (!EventsManagerImpl.instance) {
      EventsManagerImpl.instance = new EventsManagerImpl();
    }

    return EventsManagerImpl.instance;
  }

  private eventMap: EventMap;

  private constructor() {
    this.eventMap = {};
  }

  public subscribe = (name: string, func: EventCallback): EventDispose => {
    if (!this.eventMap.hasOwnProperty(name)) {
      this.eventMap[name] = [];
    }

    this.eventMap[name].push(func);

    return () => {
      const funcIndex = this.eventMap[name]?.findIndex(
        (registeredFunc) => registeredFunc === func,
      );

      if (funcIndex !== -1) {
        delete this.eventMap[name][funcIndex];
      }
    };
  };

  public clearSubscriptions = (name: string): EventCallback[] => {
    const callbacks = this.eventMap[name];
    this.eventMap[name] = [];

    return callbacks;
  };

  public publish = (name: string, data?: any): void => {
    if (this.eventMap.hasOwnProperty(name)) {
      for (const callback of this.eventMap[name]) {
        if (callback) {
          callback(data);
        }
      }
    }
  };
}
